import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsInput } from './generic-modal.service';

import { FormsModule } from '@angular/forms';
import { AutoFocusDirective } from '../auto-focus/auto-focus.directive';

@Component({
    selector: 'ep-modal-input',
    templateUrl: './modal-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, AutoFocusDirective]
})
export class ModalInputComponent {
    options: ModalSettingsInput;
    inputValue: string;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsInput;
        if (this.options.initialValue) {
            this.inputValue = this.options.initialValue;
        }
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok() {
        this.modalState.modal.close(this.inputValue);
    }
}